import React from 'react'

function TrackList() {
  return (
    <div className="trackList mx-4 mt-3">
    <ul className="list-unstyled ml-4">
      <li className="tt">
        <a href="/" >
          Web Designing
        </a>
      </li>
      <ul className="list-unstyled ml-4"> 
        <li>
          <a href="/">HTML</a>
        </li>
        <li>
          <a href="/">CSS</a>
        </li>
        <li>
          <a href="/">Bootstrap</a>
        </li>
        <li>
          <a href="/">Tailwind</a>
        </li>
      </ul>

      <li className="tt">
        <a href="/" >
          Web Development
        </a>
      </li>
      <ul className="list-unstyled ml-4">
        <li>
          <a href="/">Laravel</a>
        </li>
        <li>
          <a href="/">Nest</a>
        </li>
        <li>
          <a href="/">Django</a>
        </li>
      </ul>

      <li className="tt">
        <a href="/">
          Version Controlling
        </a>
      </li>
      <ul className="list-unstyled ml-4">
        <li>
          <a href="/">GitLab</a>
        </li>
        <li>
          <a href="/">GitBash</a>
        </li>
      </ul>
    </ul>
  </div>
    )
}

export default TrackList